import { useAppSelector } from 'app/hooks';
import Button, { ButtonWrapper } from 'blocks/Button';
import Loading from 'components/Loading';
import { getDate } from 'helper/date';
import { userTitle } from 'helper/selectConstant';
import BookFlightRequestInterface from 'models/flight/bookFlightRequest.interface';
import PassengersFormInterface from 'models/flight/passengersForm.interface';
import { UserTitlesType } from 'models/types';
import moment from 'moment-jalaali';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { discountBookFlightService } from 'services/discountFlight.service';
import { bookFlightService } from 'services/flight.service';
import { getUserService } from 'services/userInfo.service';
import {
  complementaryFormDataState,
  flightFormDataState,
  selectedFlightPriceState,
  selectedFlightState,
} from 'store/flight/flightSlice';
import { setUser, setUserInfoError, setUserInfoLoading, userInfoState } from 'store/userInfo/userInfoSlice';
import { UserInterface } from 'store/userInfo/userInfoSlice.interface';
import FlightBookPassengersForm from './form';
import { HiddenFormDataInterface } from './main.interface';
import * as S from './main.styles';

const FlightBookPassengersMain = ({ discountTicketId = null }) => {
  const formModel = {
    fname: '',
    lname: '',
    email: '',
    mobile: '',
    telephone: '',
    nationality: '',
    gender: userTitle[0].value as UserTitlesType,
    title: userTitle[0].value as UserTitlesType,
    passengerTypeCode: 'ADT',
    birthdate: '',
    docExpireDate: '',
    docId: '',
    nationalId: '',
  } as PassengersFormInterface;

  const { t } = useTranslation();
  // const passengerList = useAppSelector(formPassengersDataState);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [model, setModel] = useState<PassengersFormInterface>(formModel);
  const [hiddenFormData, setHiddenFormData] = useState<HiddenFormDataInterface>();
  const flightForm = useAppSelector(flightFormDataState);
  const selectedFlight = useAppSelector(selectedFlightState);
  const selectedFlightAmount = useAppSelector(selectedFlightPriceState);
  const userInfo = useAppSelector(userInfoState);
  const { departureCountryCode, destinationCountryCode } = useAppSelector(complementaryFormDataState);
  const dispatch = useDispatch();

  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = () => {
    dispatch(setUserInfoLoading('userInfo'));
    getUserService()
      .then((res) => {
        dispatch(setUser(res.data));
        fillInputs(res.data);
      })
      .catch((err) => {
        dispatch(setUserInfoError({ type: 'userInfo', err }));
      });
  };

  const fillInputs = (data: UserInterface) => {
    setModel({
      fname: data.enFname,
      lname: data.enLname,
      email: data.email,
      mobile: data.mobile,
      telephone: data.mobile,
      nationality: data.nationality,
      gender: data.title as UserTitlesType,
      title: data.title as UserTitlesType,
      passengerTypeCode: 'ADT',
      birthdate: data.birthdate ? moment(data.birthdate).format('YYYY-MM-DD') : '',
      docId: data.docId,
      nationalId: data.nationalId,
      docExpireDate: data.docExpireDate ? moment(data.docExpireDate).format('YYYY-MM-DD') : '',
      passportIssuingCountry: data.passportIssuingCountry,
    });
  };
  const book = async () => {
    try {
      const modelToSend = { ...model };

      const dataToSend = {
        direction: flightForm.returnDateTime ? 'OneWay' : 'Return',
        originDestinationOption: selectedFlight?.originDestinationOption,
        travelerInfos: [modelToSend],
        baseFare:
          selectedFlightAmount?.pricedItineraries.pricedItinerary[0].airItineraryPricingInfo.itinTotalFare[0].baseFare
            .amount,
        totalFare:
          selectedFlightAmount?.pricedItineraries.pricedItinerary[0].airItineraryPricingInfo.itinTotalFare[0].totalFare
            .amount,
      } as BookFlightRequestInterface;
      if (!modelToSend.fname) {
        setSubmitLoading(false);
        return toast.error('First name is empty');
      } else if (!modelToSend.lname) {
        setSubmitLoading(false);
        toast.error('Last name is empty');
      } else if (!modelToSend.nationality) {
        setSubmitLoading(false);
        toast.error('Nationality is empty');
      } else if (!modelToSend.title) {
        setSubmitLoading(false);
        toast.error('Title name is empty');
      } else if (!modelToSend.birthdate) {
        setSubmitLoading(false);
        toast.error('Date of birth is empty');
      } else if (!modelToSend.docId) {
        setSubmitLoading(false);
        toast.error('Pssport Number is empty');
      } else if (!modelToSend.passportIssuingCountry) {
        setSubmitLoading(false);
        toast.error('Passport issuing country is empty');
      } else if (!modelToSend.docExpireDate) {
        setSubmitLoading(false);
        toast.error('Passport expiration date is empty');
      } else if (modelToSend.docExpireDate <= getDate(new Date())) {
        setSubmitLoading(false);
        toast.error('Passport expiration date not valid');
      } else if (!modelToSend.mobile) {
        setSubmitLoading(false);
        toast.error('Mobile number is empty');
      } else if (!modelToSend.email) {
        setSubmitLoading(false);
        toast.error('Email is empty');
      } else {
        if (model.nationality === 'IR' && destinationCountryCode === 'IR' && departureCountryCode === 'IR') {
          delete modelToSend.docId;
        } else delete modelToSend.nationalId;

        setSubmitLoading(true);
        let responseBook;
        if (discountTicketId) {
          const discontDataToSend = { ...dataToSend, discountTicketId };
          responseBook = discountBookFlightService(discontDataToSend);
        } else {
          responseBook = bookFlightService(dataToSend);
        }
        responseBook
          .then((res) => {
            setHiddenFormData(res);

            document.getElementById('submitHiddenForm')?.click();
          })
          .catch((ex) => {
            // setSubmitLoading(false);
            toast.error(ex?.response?.data?.message);
          })
          .finally(() => {
            setSubmitLoading(false);
          });
      }
    } catch (e) {
      setSubmitLoading(false);
    }
  };

  return (
    <S.Wrapper>
      {userInfo.loading ? (
        <Loading fullScreen={false} />
      ) : (
        <>
          <S.PassengerForm>
            <FlightBookPassengersForm
              model={model}
              onChange={(newData) => {
                setModel(newData);
              }}
            />
          </S.PassengerForm>
          <S.CTA as={ButtonWrapper} justify="flex-end">
            <S.Button as={Button} loading={submitLoading} width={147} onClick={book}>
              {t('pages.services.flight.pages.book.sections.passengers.sections.form.submitCTA')}
            </S.Button>
          </S.CTA>
        </>
      )}
      {hiddenFormData != null && (
        <S.HiddenForm method={hiddenFormData.method} action={hiddenFormData.action}>
          {hiddenFormData.params.map((e) => (
            <input name={e.name} value={e?.value} />
          ))}
          <button type="submit" id="submitHiddenForm" />
        </S.HiddenForm>
      )}
    </S.Wrapper>
  );
};

export default FlightBookPassengersMain;
